import { DEFAULT_COLOR, EDesktopNavigationLayout } from '../../constants';
import { SettingsFormData } from '../../types';

export interface ImageItem {
  content: string;
  key: string;
  value: string;
  renderFunction: () => JSX.Element;
}

export const getInitialFormValues = (
  data: any,
  showLoginBtn = true
): SettingsFormData => {
  const {
    theme: {
      general = {},
      header = {},
      menu = {},
      contentCard = {},
      contentPage = {},
      footer = {},
      loginPopup = {}
    } = {},
    settings: { seo = {} } = {},
    settings = {}
  } = data;

  return {
    generalBackgroundColor: general.backgroundColor?.colorOne || DEFAULT_COLOR,
    generalSectionTextColor: general.sectionTextColor || DEFAULT_COLOR,
    generalSectionLabelFont: general.sectionLabelFont || '',
    generalFavicon: general.portalFavIcon || '',
    headerLogo: header.logo || '',
    headerBackgroundColor: header.backgroundColor?.colorOne,
    headerTextColor: header.textColor || DEFAULT_COLOR,
    headerIsPlayerNameShown: header.showPlayerName,
    headerIsPlayerIdShown: header.showPlayerId,
    headerPlayerIdFont: header.playerIdFont || '',
    headerIsPlayerBalanceShown: header.showPlayerBalance,
    headerIsLoginBtnShown: showLoginBtn ? header.showLogin : true,
    headerIsLanguageSwitcherShown: header.showTranslations,
    headerLoginButton: {
      backgroundColor:
        header.loginButton?.backgroundColor?.colorOne || DEFAULT_COLOR
    },
    settings: {
      seo: {
        portalTitle: seo.portalTitle || '',
        portalDescription: seo.portalDescription || '',
        portalKeywords: seo.portalKeywords ?? [],
        portalOGImage: seo.portalOGImage || ''
      },
      addToHomeScreen: {
        active: settings?.addToHomeScreen?.active || false,
        borderColor:
          settings?.addToHomeScreen?.borderColor?.colorOne || '#CB1010',
        backgroundColor:
          settings?.addToHomeScreen?.backgroundColor?.colorOne || '#CB1010',
        buttonImage: settings?.addToHomeScreen?.buttonImage || '',
        iconImage: settings?.addToHomeScreen?.iconImage || '',
        shortcutName: settings?.addToHomeScreen?.shortcutName || ''
      }
    },
    menuBackgroundColor: menu.backgroundColor?.colorOne || DEFAULT_COLOR,
    menuTextColor: menu.textColor || DEFAULT_COLOR,
    menuHoverColor: menu.tabHoverColor?.colorOne || DEFAULT_COLOR,
    menuNavigationFont: menu.navigationFont || '',
    menuCustomIcon: menu.customMenuIcon || '',
    menuCustomCloseIcon: menu.customMenuCloseIcon || '',
    menuDesktopNavigationLayout:
      menu.desktopNavigationLayout || EDesktopNavigationLayout.LEFT_SIDEBAR,
    selectedTabColor: menu.selectedTabColor || DEFAULT_COLOR,
    contentCardBackgroundColor:
      contentCard.backgroundColor?.colorOne || DEFAULT_COLOR,
    contentCardTextColor: contentCard.textColor || DEFAULT_COLOR,
    contentCardButtonColor: contentCard.buttonColor?.colorOne || DEFAULT_COLOR,
    contentCardButtonFont: contentCard.cardButtonFont || '',
    contentPageTextColor: contentPage.textColor || DEFAULT_COLOR,
    footerBackgroundColor: footer.backgroundColor?.colorOne || DEFAULT_COLOR,
    footerTextColor: footer.textColor || DEFAULT_COLOR,
    footerPrivacyLink: footer.privacyPolicyUrl || '',
    footerTermsConditionsLink: footer.termsOfServiceUrl || '',
    footerSupportLink: footer.supportUrl || '',
    loginPopupText: loginPopup.text || '',
    loginPopupFont: loginPopup.font || 'Roboto',
    loginPopupFontSize: loginPopup.fontSize || 12,
    loginPopupFontColor: loginPopup.fontColor || DEFAULT_COLOR,
    loginPopupFontWeight: loginPopup.fontWeight || 'regular',
    loginPopupBackgroundImageMobile: loginPopup.backgroundImageMobile || '',
    loginPopupBackgroundImageDesktop: loginPopup.backgroundImageDesktop || '',
    loginPopupLogo: loginPopup.logo || '',
    loginPopupLogoSize: loginPopup.logoSize || '',
    loginPopupConsentSection: {
      htmlText: loginPopup.consentSection?.htmlText || '',
      consentRequired: loginPopup.consentSection?.consentRequired || false
    },
    loginPopupOTPButtonIcon: loginPopup.otpButton?.icon || '',
    loginPopupOTPButtonText: loginPopup.otpButton?.text || '',
    loginPopupOTPButtonColor:
      loginPopup.otpButton?.backgroundColor?.colorOne || DEFAULT_COLOR,
    loginPopupOTPButtonTextColor:
      loginPopup.otpButton?.textColor?.colorOne || DEFAULT_COLOR
  };
};
